export default __webpack_public_path__ + "static/media/Tia_9781846164576.46a5b540.jpg";